export const Line = () => {
  return <hr className="w-full" />;
};
